import React from "react";
import { useDispatch } from "react-redux";
import { Backdrop, Button, Paper, Fade, Modal } from "@material-ui/core";
import { deletePaySlip } from "@redux/actions";
import { ToastContainer, toast } from "react-toastify";

const DeletePaySlip = ({ slip, closeModel }) => {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    dispatch(deletePaySlip(slip)).then((res) => {
      const { message, success } = res.data;

      if (success) {
        toast.success(message, {
          position: "bottom-left",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark",
          type: success ? "success" : "error",
        });

        setTimeout(() => {
          closeModel();
        }, 1000);
      } else {
        toast.error(message, {
          position: "bottom-left",
          autoClose: 3500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark",
          type: success ? "success" : "error",
        });
      }
    });
  };

  return (
    <>
      <div>
        <Modal
          open={true}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          style={modalStyle}
        >
          <Fade in={true}>
            <Paper elevation={3} variant="normal" square>
              <div style={modalHeader}>
                <p>Delete Confirmation</p>
              </div>
              <div style={modalBody}>
                Are you sure you want to delete this PaySlip?
              </div>
              <div style={modalFooter}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={closeModel}
                >
                  Close
                </Button>
                &nbsp;&nbsp;&nbsp;
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              </div>
            </Paper>
          </Fade>
        </Modal>
      </div>
      <ToastContainer />
    </>
  );
};

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Arial",
};

const modalHeader = {
  background: "#232F3E",
  color: "white",
  textAlign: "center",
  paddingTop: "10px",
  paddingBottom: "0.02px",
};
const modalBody = {
  padding: "10px",
  minWidth: "250px",
};

const modalFooter = {
  padding: "10px",
  float: "right",
};

export default DeletePaySlip;
